module.exports = __webpack_public_path__ + "img/searchCta.c78f441.png";